import exitSearch from '../../actions/search/exitSearch';
import { exitSearch as exitSearchAction, lazyEndSearchSession } from 'owa-search-actions';
import { SearchScenarioId } from 'owa-search-store';
import { getFilePickerStore } from '../../store/filePickerStore';
import { orchestrator } from 'satcheljs';

orchestrator(exitSearchAction, async actionMessage => {
    if (actionMessage.scenarioId != SearchScenarioId.FilesPicker) {
        return;
    }
    exitSearch(getFilePickerStore().viewState);

    // invoke endSearchSession common action
    const endSearchSession = await lazyEndSearchSession.import();
    endSearchSession(SearchScenarioId.FilesPicker);
});
